var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { HashLink } from 'react-router-hash-link';
import { Redirect } from 'react-router-dom';
import { Button, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCircleInfo, faCircleXmark } from '@fortawesome/pro-regular-svg-icons';
import * as yup from 'yup';
import { autoTab, CMSContent, ErrorMessage, getCMSObject, TeleScript, FindDrawNumbers, AlertBox } from '../../../index';
library.add(faCircleInfo, faCircleXmark);
/**********************************************************************
 * Component:  DrawTicketForm
 * Purpose:    Allows for the entry of Draw Tickets
 *
 * Props:       user - the user data store
 *              actions - store actions (apis)
 *              drawTicket - the draw ticket data store
 *
 * APIs used:   drawTicketActions.enterDrawTicket
 *
 *  Notes:  For MO, does not check Winning Status, only for
 *          bonusing rewards.
 */
var DrawTicketForm = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var config = _a.config, user = _a.user, actions = _a.actions, telescript = _a.telescript, drawTicket = _a.drawTicket, scanner = _a.scanner, cmsSourceFirebase = _a.cmsSourceFirebase;
    var initialDrawFields = JSON.parse(JSON.stringify((_d = (_c = (_b = config === null || config === void 0 ? void 0 : config.site) === null || _b === void 0 ? void 0 : _b.tickets) === null || _c === void 0 ? void 0 : _c.drawFields) !== null && _d !== void 0 ? _d : []));
    var ticketEntryCMS = getCMSObject('data.ticketEntry');
    var drawTicketTelescript = getCMSObject('data.components.teleScripts.drawTicket.jsonBlock');
    var _j = useState(initialDrawFields), drawFields = _j[0], setDrawFields = _j[1];
    var _k = useState(''), ticketError = _k[0], setTicketError = _k[1];
    var _l = useState(''), validationError = _l[0], setValidationError = _l[1];
    var _m = useState(false), disabled = _m[0], setDisabled = _m[1];
    var _o = useState(false), ticketSuccess = _o[0], setTicketSuccess = _o[1];
    var _p = useState(false), showModal = _p[0], setShowModal = _p[1];
    var elemRefs = [];
    useEffect(function () {
        if (disabled) {
            if (drawTicket.success) {
                updateDashboard();
                setTicketSuccess(true);
            }
            else {
                setTicketError(drawTicket.message);
            }
            setDisabled(false);
        }
        if (drawTicket.message === '_PLAYER_LOCKOUT') {
            setDisabled(true);
        }
    }, [drawTicket]);
    useEffect(function () {
        return function () {
            drawFields.forEach(function (field) {
                field.value = '';
            });
            setDrawFields([]);
            setTicketError('');
            setValidationError('');
            setDisabled(false);
            setTicketSuccess(false);
            setShowModal(false);
        };
    }, []);
    var updateDashboard = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!((user === null || user === void 0 ? void 0 : user.loggedIn) && ((_b = (_a = user === null || user === void 0 ? void 0 : user.player) === null || _a === void 0 ? void 0 : _a.actions) === null || _b === void 0 ? void 0 : _b.length) === 0)) return [3 /*break*/, 2];
                    return [4 /*yield*/, ((_c = actions === null || actions === void 0 ? void 0 : actions.userActions) === null || _c === void 0 ? void 0 : _c.getDashboard())];
                case 1:
                    _d.sent();
                    _d.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var DrawFieldInputs = function () {
        return drawFields.map(function (field, index) {
            var ref = React.createRef();
            elemRefs.push(ref);
            return (_jsxs("div", { className: 'd-inline ticket-number-inputs', children: [_jsx("input", { type: 'text', "data-index": index, ref: ref, id: field.name, className: 'theme-input mb-2 mb-sm-0', placeholder: field.placeholder, size: field.size, maxLength: field.size, defaultValue: field.value, onChange: function (event) { return handleFieldChange(event, field); }, onKeyUp: function (event) { return autoTab(event, elemRefs); }, required: true }), _jsx("span", { className: 'dash', children: "\u2014" })] }, "draw-fields--".concat(index)));
        });
    };
    var handleFieldChange = function (event, field) {
        setTicketError('');
        setValidationError('');
        var fields = drawFields;
        var value = event.target.value;
        var fieldIndex = fields.findIndex(function (obj) { return obj.name == field.name; });
        fields[fieldIndex].value = value;
        setDrawFields(fields);
    };
    var handleDrawSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var ticketString, drawEntrySchema, err_1;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    setDisabled(true);
                    setValidationError('');
                    setTicketError('');
                    setTicketSuccess(false);
                    ticketString = drawFields.map(function (field) { return field.value; }).join('');
                    drawEntrySchema = yup
                        .string()
                        .required((_a = telescript === null || telescript === void 0 ? void 0 : telescript.drawEntryFieldRequired) !== null && _a !== void 0 ? _a : 'Please completely fill out all of the entry fields.')
                        .min((_c = (_b = config === null || config === void 0 ? void 0 : config.site) === null || _b === void 0 ? void 0 : _b.tickets) === null || _c === void 0 ? void 0 : _c.drawTicketLength, 'Please completely fill out all of the entry fields.');
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, drawEntrySchema.validate(ticketString, { abortEarly: true })];
                case 2:
                    _d.sent();
                    return [4 /*yield*/, actions.drawTicketActions.enterDrawTicket({
                            ticket_number: ticketString,
                            entry_method: 'manual',
                            ticket_type: 'draw',
                        })];
                case 3:
                    _d.sent();
                    return [3 /*break*/, 6];
                case 4:
                    err_1 = _d.sent();
                    if (err_1 instanceof yup.ValidationError) {
                        setValidationError(err_1.message);
                    }
                    return [3 /*break*/, 6];
                case 5:
                    setDisabled(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var showDrawTooltip = function () {
        setShowModal(true);
    };
    var handleModalClose = function () {
        setShowModal(false);
    };
    return (_jsxs("div", { children: [ticketSuccess && _jsx(Redirect, { to: { pathname: '/post-claim', state: { motive: 'TicketEntry' } } }), validationError && _jsx(AlertBox, { variant: 'danger', message: validationError }), _jsx(ErrorMessage, { code: ticketError, collection: 'data.messages.ticketErrorMessages.jsonBlock' }), scanner && scanner, _jsxs("div", { className: 'enter-form text-center mt-3 mb-1', children: [_jsx(DrawFieldInputs, {}), _jsx(FontAwesomeIcon, { icon: ['far', 'circle-info'], className: 'ticket-tooltip', onClick: showDrawTooltip })] }), _jsx("div", { className: 'enter-form text-center theme-text-default mb-3', children: _jsx(TeleScript, { line: (_e = ticketEntryCMS === null || ticketEntryCMS === void 0 ? void 0 : ticketEntryCMS.drawTicketEntryInstructions) === null || _e === void 0 ? void 0 : _e.contentHTML, children: "Enter 25-digit alpha-numeric Webcode in box on ticket." }) }), _jsxs("div", { className: 'enter-form text-center', children: [_jsx("button", { type: 'submit', className: 'btn theme-btn theme-primary', disabled: disabled, onClick: handleDrawSubmit, children: _jsx(TeleScript, { line: drawTicketTelescript === null || drawTicketTelescript === void 0 ? void 0 : drawTicketTelescript.submitText, children: "Submit" }) }), _jsx(HashLink, { to: (_g = (_f = config === null || config === void 0 ? void 0 : config.site) === null || _f === void 0 ? void 0 : _f.ticketHistoryLink) !== null && _g !== void 0 ? _g : '/my-activity#ticket-history', className: 'view-history-link d-block mt-1', children: _jsx(TeleScript, { line: (_h = ticketEntryCMS === null || ticketEntryCMS === void 0 ? void 0 : ticketEntryCMS.ticketHistoryLink) === null || _h === void 0 ? void 0 : _h.contentHTML, children: "View your ticket history" }) })] }), _jsxs(Modal, { show: showModal, onHide: handleModalClose, children: [_jsx(Modal.Header, { closeButton: true, children: _jsx(Modal.Title, { children: _jsx(CMSContent, { localStorageObject: 'webContent', contentPath: 'data.ticketEntry.findDrawNumbers.contentHeaderText', cmsSourceFirebase: cmsSourceFirebase }) }) }), _jsx(Modal.Body, { children: _jsx(FindDrawNumbers.DrawNumbersExample, { cmsSourceFirebase: cmsSourceFirebase }) }), _jsx(Modal.Footer, { children: _jsx(Button, { className: 'btn theme-btn theme-secondary', onClick: handleModalClose, children: _jsx(TeleScript, { line: drawTicketTelescript === null || drawTicketTelescript === void 0 ? void 0 : drawTicketTelescript.closeText, children: "Close" }) }) })] })] }));
};
export default DrawTicketForm;
